<template>
    <v-layout row>
        <v-flex xs12>
            <router-view/>
            <v-tabs v-if="customer.orders_years && customer.orders_years.length > 0"
                    centered light
                    slider-color="primary">
                <v-tab
                        v-for="orders_year in customer.orders_years"
                        :key="orders_year.toString()"
                        :value="`tab-${orders_year}`"
                        @click="changeTab(orders_year.toString())"
                        @changed="changeTab(orders_year.toString())"
                >
                    {{ orders_year.toString()}}
                </v-tab>
                <v-tab-item
                        v-for="orders_year in customer.orders_years"
                        :key="orders_year.toString()"
                >
                    <v-list
                            v-for="order in orders"
                            :key="order.id"
                            two-line>
                        <v-list-tile @click="goToDetail(order.id)">
                            <v-list-tile-action class="primary">
                                <v-list-tile-title class="text-xs-center subheading text-lowercase white--text">{{order.month}}
                                </v-list-tile-title>
                                <v-list-tile-title class="text-xs-center title font-weight-bold  white--text"> {{order.day}}
                                </v-list-tile-title>
                            </v-list-tile-action>

                            <v-list-tile-content class="mr-2 ml-2">
                                <v-list-tile-title>{{order.store}}</v-list-tile-title>
                                <!-- @modified ana.castro 2019.11.25 SCLAPP-23: the purchase resume must display the purchases' total value and not the document's identifier-->
                                <!-- <v-list-tile-sub-title> {{ sale.document_identifier}}</v-list-tile-sub-title>-->
                                <v-list-tile-sub-title> {{order.total}} {{order.currency}}</v-list-tile-sub-title>
                                <v-list-tile-sub-title> {{order.status}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action v-if="order.status_code">
                                <OrdersStatus
                                        :statusCode="order.status_code"></OrdersStatus>
                            </v-list-tile-action>
                        </v-list-tile>

                    </v-list>
                    <mugen-scroll :handler="getNextOrders" :should-handle="!loading && hasMoreResults">
                        <!-- Verifying the flag which defines whether or not there are more results to load -->
                        <p v-if="loading">...</p>
                    </mugen-scroll>
                </v-tab-item>
            </v-tabs>

            <v-layout v-else align-center justify-center column>
                <v-spacer class="my-4"></v-spacer>
                <v-icon style="font-size: 150px">fal fa-shopping-cart</v-icon>
                <v-spacer class="my-4"></v-spacer>
                <h2 class="title text-xs-center">{{ $vuetify.t('$vuetify.no_movements_to_display') }}</h2>
            </v-layout>

        </v-flex>
    </v-layout>
</template>

<script>
    import {ordersService, userService} from '@/_services';
    import {getErrorMessage, getUrlParams} from '@/_helpers';
    import MugenScroll from 'vue-mugen-scroll'
    import OrdersStatus from '@/components/shop/OrdersStatus.vue';

    export default {
        name: "Orders",
        components: {MugenScroll, OrdersStatus},
        data() {
            return {
                customer: {},
                loading: false,
                hasMoreResults: true,
                nextPageUrl: null,
                orders: []
            }
        },
        methods: {
            /**
             * This function is triggered every time the user changes the displayed Tab.
             * It aims at loading the Customer's Orders for the year represented on the Tab.
             * The Customer's Orders are stored on the Orders' Array initialized on the data()
             * @param year
             */
            changeTab: function (year) {
                if (year) {
                    ordersService.getAll({year: year}).then(result => {
                            this.nextPageUrl = result.next;
                            this.hasMoreResults = this.nextPageUrl !== undefined;
                            this.orders = result.results;
                        },
                        error => {
                            getErrorMessage(error, 'Orders Change Tab', this);
                        }
                    );
                }
            },
            /**
             * This function is triggered when the user selects an Order to access its detail;
             * this works as a redirect to the Transaction's detail interface
             * @param pk
             */
            goToDetail: function (pk) {
                this.$router.push({name: 'orders-detail', params: {id: pk}})
            },
            /**
             * This function is triggered by the infinite slider. By default, only 7 Orders are displayed,
             * when the user has more than 7 Orders and scrolls on the interface,
             * this GET is triggered to obtain the following 7 Orders and append them to the Orders' Array
             */
            getNextOrders() {
                //Setting the loading flag to true
                this.loading = true;
                //Verifying there are more Orders to fetch
                if (this.nextPageUrl !== null) {
                    this.$store.dispatch("loader/setLoading", true);

                    ordersService.getAll(getUrlParams(this.nextPageUrl)).then(result => {
                            //Adding the fetched Orders to the existing list of Orders
                            this.orders = this.orders.concat(result.results);
                            this.loading = false;
                            //Updating the URL which retrieves the following 7 Orders
                            // (it has a page=X which helps on this process)
                            // When there are no more Orders to fetch, the URL is set to NULL and the flag which
                            // states whether or not the word "loading" should be displayed is set to false
                            this.nextPageUrl = result.next;
                            this.hasMoreResults = this.nextPageUrl !== undefined;
                            this.$store.dispatch("loader/setLoading", false);
                        },
                        error => {
                            getErrorMessage(error, 'Getting the Orders', this);
                        }
                    );
                } else
                    this.loading = false
            }
        },
        watch: {
            /**
             * Every time the customer yields a different result (the first time we enter this page)
             * the function which loads values for the first tab is called.
             * The aim is to get all the Orders the customer had during the most recent year;
             * if the customer has no "orders_years" then the service to get the data should not be called
             */
            customer: function () {
                if (this.customer !== undefined) {
                    if (this.customer.orders_years[0]) {
                        this.changeTab(this.customer.orders_years[0]);
                    }
                }
            }
        },
        mounted() {
            userService.get().then(data => this.customer = data);
        },
    }
</script>

<style scoped>

</style>